<template>
  <hypto-popup :title="'Create Refund'">
    <template #body>
      <div class="merge-fields">
        <md-field>
          <label>Order ID</label>
          <md-input
            v-model="details.order_id"
            :disabled="true"
          />
        </md-field>

        <md-field :class="{'input-error': $v.refNum.$error}">
          <label>Reference Number</label>
          <md-input
            v-model="refNum"
            @blur="$v.refNum.$touch()"
          />
        </md-field>
        <h6 class="error-message" v-if="$v.refNum.$error && !$v.refNum.required">Please enter reference number</h6>
        <h6 class="error-message" v-if="$v.refNum.$error && !$v.refNum.refNum">Reference Number should contain only alphanumeric characters, hyphen, underscore or dot</h6>

        <md-field :class="{'input-error': $v.amount.$error}">
          <label>Amount</label>
          <md-input
            v-model="amount"
            :type="isDesktop() ? 'text' : 'number'"
            @keypress="allowAmountFormat($event, amount)"
            @blur="$v.amount.$touch()"
          />
        </md-field>
        <i class="amount">{{words}}</i>
        <h6 class="error-message" v-if="$v.amount.$error && !$v.amount.required">Please enter amount value</h6>
        <h6 class="error-message" v-else-if="$v.amount.$error && !$v.amount.amount">Please enter only numeric values (upto 2 decimals)</h6>
        <h6 class="error-message" v-else-if="$v.amount.$error && !$v.amount.limit">Please enter refund amount less than or equal to order amount</h6>

        <md-field :class="{'input-error': $v.note.$error}">
          <label>Note</label>
          <md-input
            v-model="note"
            @blur="$v.note.$touch()"
            @keyup.enter="createRefund"
          />
        </md-field>
        <h6 class="error-message" v-if="$v.note.$error && !$v.note.required">Please enter a Note</h6>
        <h6 class="error-message" v-else-if="$v.note.$error && !$v.note.minLength">Note should contain atleast 2 characters</h6>
        <h6 class="error-message" v-else-if="$v.note.$error && !$v.note.alphaNumericSpace">Note should contain only alphanumeric characters and space</h6>
      </div>
    </template>

    <template #footer>
      <h6 class="error-message" v-if="errorMsg">{{errorMsg}}</h6>
      <button class="primary-btn align-r" @click="createRefund">Create</button>
    </template>
  </hypto-popup>
</template>

<script>
import HyptoPopup from '@/components/global/HyptoPopup'

import ApiServices from '@/services/api/pgRefunds'
import numToWords from '@/mixins/numToWords'
import { required, minLength } from 'vuelidate/lib/validators'
import { amount, refNum, alphaNumericSpace } from '@/utils/helpers/validators'
import { allowAmountFormat, openPopup } from '@/utils/helpers'

const limit = (amount) => (amtLimit) => {
  return amount >= amtLimit
}

export default {
  name: 'RefundCreate',
  components: { HyptoPopup },
  mixins: [numToWords],
  props: {
    details: Object
  },
  data () {
    return {
      note: null,
      refNum: null,
      errorMsg: null
    }
  },
  validations () {
    return {
      amount: {
        required,
        amount,
        limit: limit(this.details.amount)
      },
      refNum: {
        required,
        refNum
      },
      note: {
        required,
        alphaNumericSpace,
        minLength: minLength(2)
      }
    }
  },
  watch: {
    amount () {
      this.convertWords()
    }
  },
  created () {
    this.watchCollection(['refNum', 'note', 'amount'], () => {
      this.errorMsg = null
    })
  },
  methods: {
    openPopup,
    allowAmountFormat,
    watchCollection (arr, cb) {
      arr.forEach((val) => this.$watch(val, cb))
    },
    getParams () {
      return {
        reference_id: this.refNum,
        amount: parseFloat(this.amount),
        note: this.note
      }
    },
    createRefund () {
      this.$v.$touch()

      if (!this.$v.$error) {
        const PARAMS = this.getParams()

        ApiServices.create(this.details.id, PARAMS).then(response => {
          if (response.success) {
            this.openPopup(null)
            this.$router.push({name: 'Refunds'})
            this.successToastMsg(response.message)
          } else {
            this.errorToastMsg(response.message)
          }
        }).catch(error => {
          this.errorMsg = error.body.reason
        })
      }
    }
  }
}
</script>

<style lang="scss" scoped>
  @import '@/assets/scss/mixins.scss';

  .amount {
    color: $grey-light;
    display: block;
    text-align: left;
    font-size: 12px;
  }
</style>
